import { render, staticRenderFns } from "./doHistoryComplaintsList.vue?vue&type=template&id=a03ccc14&scoped=true"
import script from "./doHistoryComplaintsList.vue?vue&type=script&lang=js"
export * from "./doHistoryComplaintsList.vue?vue&type=script&lang=js"
import style0 from "./doHistoryComplaintsList.vue?vue&type=style&index=0&id=a03ccc14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03ccc14",
  null
  
)

export default component.exports